export { default } from './ContingutEstatic';
